var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleinvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12457_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40039 1.5H18.3418L18.4141 1.51562C18.4724 1.54122 18.5041 1.59311 18.5098 1.6377C18.5077 1.67524 18.4935 1.71198 18.4658 1.74023C18.4363 1.77017 18.4016 1.7832 18.3701 1.7832C17.2218 1.78333 16.2959 2.67263 16.2959 3.81543V15.291C16.2959 16.5028 15.2937 17.5 14.0352 17.5H4.76074C3.50222 17.5 2.5 16.5028 2.5 15.291V14.0557C2.50013 13.9844 2.55828 13.9141 2.6543 13.9141H5.03027V3.81543C5.03032 2.54429 6.08136 1.5 7.40039 1.5ZM2.80762 15.291C2.80762 16.372 3.68237 17.2168 4.76074 17.2168H12.46L12.1426 16.5117L11.9609 16.1084L11.96 16.1064C11.845 15.8525 11.7871 15.5782 11.7871 15.291V14.1855H2.80762V15.291ZM7.40039 1.7832C6.2615 1.7832 5.33794 2.67505 5.33789 3.81543V13.9141H11.9287C12.0247 13.9141 12.0829 13.9844 12.083 14.0557V15.291C12.083 16.2323 12.7487 16.9952 13.668 17.1826L13.7012 17.1992L13.8027 17.2041L14.0205 17.2158L14.0342 17.2168H14.0479C15.1234 17.2167 16.001 16.3866 16.001 15.291V3.70312C16.0119 3.43637 16.0779 3.17298 16.1963 2.91016L16.3896 2.49414L16.7207 1.7832H7.40039Z",
    fill: "#4F5E71",
    stroke: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61837 6.15544H9.08347C9.38617 6.15544 9.64045 5.91785 9.64045 5.62085C9.64045 5.47829 9.59201 5.33574 9.48304 5.22882C9.37406 5.1219 9.24087 5.0625 9.07136 5.0625H7.58204C7.43674 5.0625 7.30355 5.13378 7.20669 5.2407C7.09771 5.34762 7.04928 5.49017 7.06139 5.63273C7.07349 5.91785 7.31566 6.15544 7.61837 6.15544Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5849 9.61328H7.58204C7.43674 9.62516 7.30355 9.68456 7.20669 9.79148C7.09771 9.8984 7.04928 10.041 7.06139 10.1835C7.07349 10.4805 7.31566 10.7062 7.61837 10.7062H10.597C10.8997 10.7062 11.1419 10.4686 11.154 10.1716C11.154 10.0291 11.1055 9.88652 10.9966 9.7796C10.8876 9.67268 10.7423 9.61328 10.5849 9.61328Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0258 7.34375H7.56993C7.43674 7.35563 7.30355 7.41503 7.20669 7.52195C7.09771 7.62886 7.04928 7.77142 7.06139 7.91398C7.07349 8.21098 7.31566 8.43669 7.61837 8.43669H12.05C12.3527 8.43669 12.5949 8.1991 12.607 7.9021C12.607 7.75954 12.5585 7.61699 12.4496 7.51007C12.3285 7.40315 12.1953 7.34375 12.0258 7.34375Z",
    fill: "#4F5E71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12457_2105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleinvoiceIcon);
export default __webpack_public_path__ + "static/media/SaleinvoiceIcon.a218c06cf7f1081049022b3e68efb87d.svg";
export { ForwardRef as ReactComponent };